import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import EpiContext from '@episerver/spa-core/Spa';
import tv from './images/tv.svg';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import Popup from '../../Shared/Popup/PopUp';
import PopupContent from './PopupContent';
import {setSuccessMessage, getTvCode, setPasswordUpdate, setIsPasswordUpdate} from './TvActivationCodeRecoveryBlockSlice';
import Config from 'app/Config';

const SubscriptionInformation = (props) => {
  const [popupType, setPopupType] = useState(null);

  useEffect(() => {
    if (props.isPasswordUpdate) {
      props.setPasswordUpdate();
    }
    props.setIsPasswordUpdate(false);
  }, [props.isPasswordUpdate]);

  const handlePopup = async (type) => {
    setPopupType(type);
  };

  const handleOnContinue = () => {
    EpiContext.navigateTo(Config.lobbyUrl);
  };

  return (
    <div className='subscription-information'>
      <div className='title'>פרטי מנוי ל{window.Config.brand_Name_HE} TV</div>
      <Image className='img' src={tv} alt='image' />
      <div className='container-info'>
        <div>פרטי כניסה לאפליקציה/ממיר</div>
        <div>
          שם משתמש: <span>{props.TvActivationCodeRecovery.infoTv.tvEmail}</span>
        </div>
        <div>
          סיסמא: <span>{props.TvActivationCodeRecovery.infoTv.tvCode}</span>
        </div>
      </div>
      <div className='container-links'>
        <button onClick={() => handlePopup('passwordResetPopUp')}>לאיפוס הסיסמא</button>
        <button onClick={() => handlePopup('sendingCodePopUp')}>לשליחת הסיסמא במייל וב-SMS</button>
        <button onClick={() => handlePopup('downloadingAppPopUp')}>להורדת האפליקציה</button>
      </div>

      <BtnWhite onclick={handleOnContinue} text='לאיזור האישי' />

      <Popup showPopUp={!!popupType} onClose={() => setPopupType(null)}>
        <PopupContent contentType={popupType} setPopupType={setPopupType} />
      </Popup>
    </div>
  );
};

const mapStateToProps = (state) => ({
  selectedCustomer: state.TvActivationCodeRecovery.selectedCustomer,
  TvActivationCodeRecovery: state.TvActivationCodeRecovery,
  isPasswordUpdate: state.TvActivationCodeRecovery.isPasswordUpdate,
});

const mapDispatchToProps = {
  setSuccessMessage,
  getTvCode,
  setPasswordUpdate,
  setIsPasswordUpdate,
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionInformation);
